import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import { Routes } from 'constants/route.constants';
import { Button, UnavailableModule } from 'common/components';
import { ReactComponent as NoEntranceIcon } from 'img/icons/no-entrance.svg';
import messages from 'modules/front-desk/messages/messages';
import commonMessages from 'common/messages/messages';

const useStyles = makeStyles(() => ({
  buttons: {
    '& .unavailableModuleBtns > button': {
      flex: 1,
    },
  },
}));

const EntranceNotCreated = (): JSX.Element => {
  const navigate = useNavigate();
  const classes = useStyles();

  return (
    <UnavailableModule
      lockIcon={<NoEntranceIcon />}
      title={<FormattedMessage {...messages.entranceNotCreatedLabel} />}
      className={classes.buttons}
      additionalButton={
        <Button
          color="primary"
          variant="contained"
          onClick={() => navigate(Routes.CLUB_SETTINGS_WORKING_HOURS)}
        >
          <FormattedMessage {...commonMessages.configureBtn} />
        </Button>
      }
    />
  );
};

export default EntranceNotCreated;
